var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"align-center"},[_vm._v("Add new image set")]),_vm._v(" "),_c('create-form',{attrs:{"save":_vm.create}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }